import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiX } = FiIcons;

const SearchBar = ({ searchQuery, setSearchQuery, selectedTags, onTagRemove }) => {
  return (
    <div className="max-w-2xl mx-auto w-full">
      <div className="relative group">
        <SafeIcon
          icon={FiSearch}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 text-xl group-focus-within:text-yellow-500 transition-colors"
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search businesses, people..."
          className="w-full pl-12 pr-12 py-4 text-base md:text-lg border border-slate-200 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all bg-white appearance-none"
          style={{ fontSize: '16px' }} /* Prevent iOS zoom on focus */
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery('')}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
            aria-label="Clear search"
          >
            <SafeIcon icon={FiX} className="text-lg" />
          </button>
        )}
      </div>

      <AnimatePresence>
        {selectedTags.length > 0 && (
          <div className="flex flex-nowrap overflow-x-auto gap-2 mt-4 pb-2 -mx-4 px-4 md:mx-0 md:px-0 no-scrollbar">
            {selectedTags.map((tag) => (
              <motion.span
                key={tag}
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                className="flex-shrink-0 inline-flex items-center px-4 py-2 rounded-xl text-sm font-medium bg-slate-900 text-white shadow-sm"
              >
                {tag}
                <button
                  onClick={() => onTagRemove(tag)}
                  className="ml-2 p-0.5 rounded-full hover:bg-slate-700 active:bg-slate-600 transition-colors"
                >
                  <SafeIcon icon={FiX} className="text-xs" />
                </button>
              </motion.span>
            ))}
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SearchBar;